import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@env/environment';

const baseApi = environment.BASE_API;

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  saveDocument(document: any, id: string, qrCode?: string): Observable<any> {
    const key = sessionStorage.getItem('k');
    const header = new HttpHeaders({'Content-Type': 'application/json'});

    let url = `${baseApi}/documents/${id}?k=${key}`;
    if (qrCode) {
      url += `&qrcode=${qrCode}`;
    }

    return this.http.post(url, document, {headers: header});
  }

  sendComplete(document: any, id: string): Observable<any> {
    const key = sessionStorage.getItem('k');
    const header = new HttpHeaders({'Content-Type': 'application/json'});

    return this.http.post(`${baseApi}/documents/${id}?action=SEND&k=${key}`, document, {headers: header});
  }

}
